module.exports = __webpack_public_path__ + "static/media/mastercard.svg.fe2185eb.png";